var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.30016 1.54698C8.88538 0.317675 11.1146 0.317675 12.6998 1.54698L17.6998 5.42438C18.7559 6.24331 19.375 7.49778 19.375 8.82856V15.0488C19.375 17.4458 17.4085 19.375 15 19.375H5C2.59151 19.375 0.625 17.4458 0.625 15.0488V8.82856C0.625 7.49778 1.24413 6.24331 2.30016 5.42438L7.30016 1.54698ZM6.5625 13.75C6.21731 13.75 5.9375 14.0298 5.9375 14.375C5.9375 14.7202 6.21731 15 6.5625 15H13.4375C13.7827 15 14.0625 14.7202 14.0625 14.375C14.0625 14.0298 13.7827 13.75 13.4375 13.75H6.5625Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.295ab2abeb8df99368e9ab04ea53706b.svg";
export { ForwardRef as ReactComponent };